module.exports = __webpack_public_path__ + "static/img/page_04.077f4a68.png";